import React, { useEffect, useState } from "react";
import WrapperFiltroSection from "../utilities/WrapperFiltroSection";
import classes from "./FormColors.module.css";
import { all_colors } from "../../catalog/lista_cores";

const colors = all_colors;

const FormCores = ({ setFilter, filterVal }) => {
  const [selectedColors, setSelectedColors] = useState([]);

  //Trocar cores selecionadas
  const handleChange = ({ target }) => {
    if (target.checked) {
      setSelectedColors([...selectedColors, target.value]);
    } else {
      setSelectedColors((currValue) => {
        return currValue.filter((val) => val !== target.value);
      });
    }
  };

  useEffect(() => {
    setFilter(selectedColors);
  }, [setFilter, selectedColors]);

  useEffect(() => {
    setSelectedColors(filterVal);
  }, [filterVal]);

  return (
    <WrapperFiltroSection title="Cores">
      <form className={classes.listColors}>
        {colors.map((item) => (
          <div
            className={`${classes.colorItem} ${
              selectedColors.includes(item.colorName) ? classes.checked : ""
            }`}
            key={item.colorName}
          >
            <label
              htmlFor={item.colorName}
              style={{ backgroundColor: item.colorBackground }}
              className={classes.btnColor}
              title={item.colorName}
            >
              <span>{item.colorName}</span>
            </label>
            <input
              type="checkbox"
              name="colors"
              id={item.colorName}
              value={item.colorName}
              onChange={handleChange}
              checked={selectedColors.includes(item.colorName)}
            />
          </div>
        ))}
      </form>
    </WrapperFiltroSection>
  );
};

export default FormCores;
